import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyWaveGw',
	friendly_name: 'Wave Gateway',
	family: 'gateway',
	isPM: false,
	modes: {
		gateway: {
			channels: 1,
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				scripts_gen_2,
				networks_gen_2_pro,
				bluetooth_gen_2,
				{
					title: 'settings',
					components: [
						{ title: 'device_name', component: 'device_name_sys' },
						{
							title: 'device_card_customization',
							component: 'customize_device_content',
						},
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'frequency_listener', component: 'frequency_listener_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
